import {addEventTodo, deleteEventTodo, updateEventTodo} from "../Todo/BrowserDatabaseFunctions";


export const E_addEventTodoResults = async (_incoming) => {
    console.log("E_addEventTodoResults");

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newTodo = _incoming.to_do; // should already contain { id, temp_id?, ... }

        if (!eventId || !newTodo) {
            console.error("Missing event_id or to_do in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventTodo(eventId, newTodo);
            console.log("Todo added successfully");
        } catch (error) {
            console.error("Error adding Todo to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventTodoResults = async (_incoming) => {
    console.log("E_updateEventTodoResults");

    /*
        an Event Todo was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventTodo(_incoming.event_id, _incoming.updated_todo_item);
                console.log("Todo updated successfully");
            } catch (error) {
                console.error("Error updating Todo: ", error);
            }

            return null; // Return the updated to_do regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventTodoResults = async (_incoming) => {
    console.log("E_deleteEventTodoResults");

    /*
        an Event Todo was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventTodo(_incoming.event_id, _incoming.todo_id);
                console.log("Todo deleted successfully");
            } catch (error) {
                console.error("Error deleting Todo: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}